<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editDocument') }}</h1>
      <div class="form-container">
        <DocumentForm @save="save"
                      :edit-mode="true"
                      :document-data="documentData">
        </DocumentForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import DocumentForm from '@/components/DocumentForm'

  export default {
    components: {
      DashboardLayout,
      DocumentForm
    },
    methods: {
      save(documentForm) {
        this.$store.dispatch('Document/update', documentForm).then(document => {
          this.$router.push({
            name: 'documentDetail',
            params: {documentId: document.id}
          })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Document/getRelations', this.$route.params.documentId)
    },
    computed: {
      ...mapState('Document', ['document']),
      documentData() {
        return this.document ? {
          ...this.document,
          legal_doc_date: this.document.legal_doc_date ? new Date(this.document.legal_doc_date) : null,
          outgoing_doc_date: this.document.outgoing_doc_date ? new Date(this.document.outgoing_doc_date) : null,
          term_date: this.document.term_date ? new Date(this.document.term_date) : null
        } : {}
      },
      breadcrumbs() {
        return [
          { name: 'documents', path: 'documents' },
          {
            name: 'documentDetail',
            path: {
              name: 'documentDetail',
              params: {documentId: this.$route.params.documentId}
            }
          },
          { name: 'editDocument' }
        ]
      }
    }
  }
</script>